import { CmsApplianceDetailsModelSerialApplianceExists } from '../../models/appliance-details-model-serial/cms-appliance-details-model-serial-appliance-exists.interface';

export const mockCmsApplianceDetailsModelSerialApplianceExists: CmsApplianceDetailsModelSerialApplianceExists =
  {
    title: 'title',
    body: '<p>body</p>',
  };
